module.exports = __webpack_public_path__ + "static/media/pformbgleft.11457498.webp";